import React from 'react';
import { useTranslation } from 'react-i18next';
import Forex from "../assets/forex.png"
import Stocks from "../assets/stocks.png"
import Commodity from "../assets/commoditly.png"
import Crypto from "../assets/crypto.png"
import Indices from "../assets/indices.png"
import HighYield from "../assets/high-yield.png"

const InvestmentProductsCards = () => {
    const { t } = useTranslation();

    const datas = [
        {
            title: t("Forex (Döviz Piyasası)"),
            description: t("Paragon Yatırım, döviz çiftleri üzerinde işlem yaparak kazanç elde etmenizi sağlar. Forex piyasası, yüksek likidite ve 24/7 işlem fırsatları sunar. Küresel ekonomi verilerinden etkilenen döviz çiftleriyle hızlı ve kârlı ticaret yapabilirsiniz."),
            image: Forex
        },
        {
            title: t("Hisse Senetleri"),
            description: t("Dünya borsalarında işlem gören büyük şirketlerin hisse senetlerine yatırım yapabilirsiniz. Paragon Yatırım, hisse senetleri aracılığıyla hisse alım-satımı yaparak portföyünüzü çeşitlendirme ve uzun vadeli kazanç sağlama fırsatı sunar."),
            image: Stocks
        },
        {
            title: t("Emtialar"),
            description: t("Altın, gümüş, petrol gibi değerli metaller ve enerji ürünleri üzerine yatırım yaparak, ekonomik dalgalanmalardan faydalanabilirsiniz. Emtialar, özellikle kriz dönemlerinde güvenli liman arayan yatırımcılar için ideal bir seçenektir."),
            image: Commodity
        },
        {
            title: t("Kripto Paralar"),
            description: t("Bitcoin, Ethereum gibi dijital varlıklara yatırım yaparak, yeni nesil finansal piyasaların içinde yer alabilirsiniz. Kripto para piyasası yüksek volatilite sunar ve potansiyel büyük kazançlar sağlar."),
            image: Crypto
        },
        {
            title: t("Endeksler"),
            description: t("Küresel borsaların genel performansını yansıtan endeksler üzerinden işlem yapabilirsiniz. Endeksler, birçok hisse senedini tek bir varlıkla takip etme imkânı sunarak, yatırımcıların risklerini daha kolay yönetmelerini sağlar."),
            image: Indices
        },
        {
            title: t("Yüksek Getiri Hesap Türleri"),
            description: t("Farklı risk profillerine göre tasarlanmış hesap türleri ile kısa vadeli ve uzun vadeli yatırım stratejileri oluşturabilirsiniz. Paragon Yatırım, yatırımcıların hedeflerine göre özelleştirilmiş hesap seçenekleri sunarak, kazançlarını maksimuma çıkarmayı hedefler."),
            image: HighYield
        },
    ]
    return (
        <div className="investment-products-cards-content">
            <div className="container">
                <div className="row">
                    {
                        datas.map((data, index) => (
                            <div className="col-lg-6 mb-4" key={index}>
                                <div className="investment-product-card shadow-sm" style={{ backgroundImage: `url(${data.image})` }}>
                                    <div className="investment-product-card-header">
                                        <h3>{data.title}</h3>
                                    </div>
                                    <div className="investment-product-card-body">
                                        {data.description}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default InvestmentProductsCards;
